import React, { CSSProperties, FC } from 'react';

type LogoProps = {
  inlineStyle?: Pick<
    CSSProperties,
    'width' | 'height' | 'fill' | 'color' | 'verticalAlign'
  >;
};

export const Chat: FC<LogoProps> = ({ inlineStyle = {} }: LogoProps) => (
  <svg viewBox="0 0 18 18" style={{ ...inlineStyle, width: 18, height: 18 }}>
    <path
      d="M18 9C18 13.3492 13.9706 16.875 9 16.875C8.08115 16.875 7.19446 16.7545 6.35944 16.5306C5.70261 16.8635 4.19371 17.5032 1.65569 17.9187C1.43179 17.9554 1.26041 17.7211 1.34885 17.5122C1.74722 16.5711 2.10657 15.3182 2.21601 14.1751C0.835944 12.7911 0 10.981 0 9C0 4.65076 4.02944 1.125 9 1.125C13.9706 1.125 18 4.65076 18 9ZM5.625 9C5.625 8.37868 5.12132 7.875 4.5 7.875C3.87868 7.875 3.375 8.37868 3.375 9C3.375 9.62132 3.87868 10.125 4.5 10.125C5.12132 10.125 5.625 9.62132 5.625 9ZM10.125 9C10.125 8.37868 9.62132 7.875 9 7.875C8.37868 7.875 7.875 8.37868 7.875 9C7.875 9.62132 8.37868 10.125 9 10.125C9.62132 10.125 10.125 9.62132 10.125 9ZM13.5 10.125C14.1213 10.125 14.625 9.62132 14.625 9C14.625 8.37868 14.1213 7.875 13.5 7.875C12.8787 7.875 12.375 8.37868 12.375 9C12.375 9.62132 12.8787 10.125 13.5 10.125Z"
      fill="white"
    />
  </svg>
);

export const Call: FC<LogoProps> = ({ inlineStyle = {} }: LogoProps) => (
  <svg viewBox="0 0 16 16" style={{ ...inlineStyle, width: 18, height: 18 }}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.88477 0.511076C2.62689 -0.231039 3.85149 -0.154797 4.49583 0.673634L6.28954 2.97983C6.6187 3.40304 6.73502 3.95409 6.60498 4.47423L6.05772 6.66329C5.99994 6.8944 6.06766 7.13888 6.2361 7.30732L8.69268 9.7639C8.86113 9.93235 9.1056 10.0001 9.33671 9.94229L11.5258 9.39502C12.0459 9.26499 12.597 9.3813 13.0202 9.71047L15.3264 11.5042C16.1548 12.1485 16.231 13.3731 15.4889 14.1152L14.455 15.1492C13.7153 15.8889 12.6089 16.2137 11.5778 15.8512C9.01754 14.9511 6.61438 13.4774 4.56849 11.4315C2.5226 9.38562 1.04895 6.98246 0.148838 4.42225C-0.213682 3.39112 0.11113 2.28472 0.85085 1.545L1.88477 0.511076Z"
      fill="white"
    />
  </svg>
);
